import React, { Component } from "react";

import Slider from "../../SliderView/MainSlider";
import api from "../../../Environment";
import ContentLoader from "../../Static/contentLoader";
import Helper from "../../Helper/helper";

class History extends Helper {
  state = {
    histories: null,
    loading: true,
  };

  componentDidMount() {
    const inputData = {
      skip: 0,
    };

    api
      .postMethod("history/list", inputData)
      .then((response) => {
        if (response.data.success === true) {
          let histories = response.data.data || [];
          this.setState({ loading: false, histories: histories });
        } else {
          this.errorCodeChecker(response.data.error_code);
          this.setState({ loading: false, histories: [] });
        }
      })
      .catch(() => {
        this.setState({ loading: false, histories: [] });
      });
  }

  chunkArray(myArray, chunk_size) {
    let results = [];
    const source = Array.isArray(myArray) ? [...myArray] : [];

    while (source.length) {
      results.push(source.splice(0, chunk_size));
    }

    return results;
  }

  render() {
    if (this.state.loading) {
      return <ContentLoader />;
    }

    const histories = this.state.histories || [];
    const result = this.chunkArray(histories, 5);

    return (
      <div className="main p-40">
        <div className="main-slidersec">
          <h3 className="">
            Recently Watched
            <i className="fas fa-angle-right ml-2" />
          </h3>
          {result.length === 0 ? (
            <p className="text-muted">No watch history yet.</p>
          ) : (
            result.map((res, index) => (
              <Slider key={`history-row-${index}`}>
                {res.map((movie) => (
                  <Slider.Item movie={movie} key={movie.admin_video_id}>
                    item1
                  </Slider.Item>
                ))}
              </Slider>
            ))
          )}
        </div>
        <div className="height-100" />
      </div>
    );
  }
}

export default History;
